import { configureStore } from '@reduxjs/toolkit'
import userSlice from 'features/user/userSlice'
import cartSlice from 'features/cart/cartSlice'
import categoriesSlice from 'features/categories/categoriesSlice'
import logger from "redux-logger";
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { combineReducers } from 'redux'

const reducer = combineReducers({
    user: userSlice,
    cart: cartSlice,
    categories: categoriesSlice,
})

// redux persist
const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['cart']
}

const persistedReducer = persistReducer(persistConfig, reducer)

const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
    }).concat([process.env.NODE_ENV === 'development' && logger].filter(Boolean)),
    devTools: process.env.NODE_ENV === 'development'
})

export const persistor = persistStore(store)

export default store